export default __webpack_public_path__ + "static/media/ftj-4.666dca37.jpeg";